import { styled } from "styled-components";

import { Image } from "common/components";

export const SourceDetailContainer = styled.div`
  display: flex;
  width: 100%;
`;

export const SourceDetailColumnContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  flex: 1;
`;

export const SourceAttributeLabel = styled.p`
  font-weight: bold;
  margin: 0;
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.textBright};
`;

export const SourceAttributeValue = styled.p`
  margin: 0;
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.textFade};
`;

export const SourceImage = styled(Image)`
  width: 100px;
  height: 100px;
  border-radius: 4px;
  margin-right: 1rem;
  object-fit: contain;
`;
